export default __webpack_public_path__ + "static/NetworkSeC-eaf16b8b0fae834bae5625a2e6f749a2.png";